var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsGreenOk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 -0.205)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.768,5.078l-.035.041h0l-10.083,11.7a.9.9,0,0,1-.68.312h0a.9.9,0,0,1-.681-.319L8.045,12.974h0a1.792,1.792,0,0,1,.216-2.528l1.155,1.372h0l2.56,3.036L21.408,3.906h0a.9.9,0,0,1,1.359,1.172Zm-.442,4.427-.293-1.011L20.6,9.986a7.49,7.49,0,0,1,.228,2.332A8.523,8.523,0,1,1,12.3,3.794,8.861,8.861,0,0,1,18,5.9l1.157-1.371A10.656,10.656,0,0,0,12.3,2,10.317,10.317,0,1,0,22.619,12.317,9.255,9.255,0,0,0,22.326,9.505Z",
    transform: "translate(-0.445 -1.143)",
    fill: "#58ab27"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGreenOk);
export default __webpack_public_path__ + "static/media/icons-green-ok.0d265e0c.svg";
export { ForwardRef as ReactComponent };